<template>
    <nav class="navbar navbar-expand-lg bg-light shadow-sm py-3 fixed-top" id="navbarScroll">
  <div class="container-fluid container-lg">
    <a class="navbar-brand" href="/"><img src="../assets/dacodeblue.svg" height="40" width="160" alt="Dacode Blue Logo"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ms-auto mb-4 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" href="/">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#curriculum">Curriculum</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#register">Register</a>
        </li>
      </ul>

      <div class="ms-0 ms-lg-5 mb-3 mb-lg-0">
        <a class="call-to-action"
          href="https://api.whatsapp.com/send?phone=2348132961732&text=Hello%20Dacode%20%F0%9F%91%8B" target="_blank"><i class="fab fa-whatsapp"></i> Chat Us</a>
      </div>
    </div>
  </div>
</nav>
</template>

<script>
export default {

}
</script>
